module.exports = __webpack_public_path__ + "img/settings-account.4e611890.svg";